import { useEffect, useState } from 'react';
import CalendarMonthShifter from '../CalendarMonthShifter';
import { DateTime, Info } from 'luxon';
import cc from 'classcat';

interface IMonthPicker {
    currentMonth: DateTime;
    updateCalendarFromMonthPicker: (date: DateTime) => void;
}

const MonthPicker = ({ currentMonth, updateCalendarFromMonthPicker }: IMonthPicker) => {
    const [displayCalendar, setDisplayCalendar] = useState(false);
    const months = Info.months();

    const [displayDate, setDisplayDate] = useState<DateTime>(currentMonth);

    const onSubmit = (index: number) => {
        const newDate = DateTime.fromObject({ year: displayDate.year, month: index + 1 }).startOf('month');
        setDisplayDate(newDate);
        updateCalendarFromMonthPicker(newDate);
        setDisplayCalendar(false);
    };

    useEffect(() => {
        setDisplayDate(currentMonth);
    }, [currentMonth.toISO()]);

    return (
        <>
            <button
                className={cc([
                    'icon-button',
                    `icon-button--square`,
                    { 'icon-button--contained month-picker__btn-contained': displayCalendar },
                    { 'icon-button--outlined month-picker__btn-outlined': !displayCalendar },
                ])}
                onClick={() => setDisplayCalendar(prev => !prev)}
            >
                <img src={displayCalendar ? '/svg/calendar-white.svg' : '/svg/calendar-blue.svg'} alt="calendar" />
            </button>

            {displayCalendar && (
                <>
                    <div className="month-picker">
                        <div className="month-picker__header">
                            <CalendarMonthShifter
                                currentDate={displayDate}
                                previous={() => setDisplayDate(prev => prev.minus({ year: 1 }))}
                                next={() => setDisplayDate(prev => prev.plus({ year: 1 }))}
                                formatOptions={{ year: 'numeric' }}
                            />
                        </div>
                        <div className="month-picker__body">
                            {months.map((month, index) => (
                                <div
                                    key={month}
                                    onClick={() => onSubmit(index)}
                                    className={cc([
                                        'month-picker__tile',
                                        {
                                            'month-picker__tile__selected':
                                                index + 1 === displayDate.month && displayDate.hasSame(currentMonth, 'year'),
                                        },
                                    ])}
                                >
                                    {month.slice(0, 3)}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="event-bubbling-mask" onClick={() => setDisplayCalendar(false)}></div>
                </>
            )}
        </>
    );
};

export default MonthPicker;
